"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewslettersPlugin = void 0;
const base_1 = require("../base");
class NewslettersPlugin extends base_1.BasePlugin {
    constructor() {
        super(...arguments);
        this.defaultConfig = {
            injectOn: ['A'],
            maxInjections: 1,
            visibleOn: ['A', 'B', 'C', 'D'],
        };
    }
    generateMarkup(config, contextConfig) {
        const { breakpoint } = contextConfig;
        const { id } = config;
        return this.generateSlotMarkup({
            slotName: 'newsletters',
            slotConfig: { id, breakpoint },
        });
    }
}
exports.NewslettersPlugin = NewslettersPlugin;
//# sourceMappingURL=index.js.map